import React from "react";
import "./EventCreateForm.css";
import { useEffect } from "react";
import { useState } from "react";
import { post } from "../../../../../Script/Session";
import { Token } from "../../../../../Script/Session";
import { useNavigate } from "react-router-dom";
import Stylebutton from "../../../../../components/buttons/stylebutton/Stylebutton";
const EventCreateForm = ({setmask}) => {
    const [data, setdata]  = useState("{}");
    const [filteredata, setfilterdata] = useState("{}");
    const [loading, setLoading] = useState(true); 
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
    
            try {
                const body = {
                    token: Token.get(),
                    action: "getActions",
                };
    
                const response = await post(body, "/EditEvents");
    
                if (!response) {
                    alert("EventErstellung hat einen Fehler!");
                    return;
                }
    
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }
    
                const json = JSON.parse(response);
                setdata(json);
                setfilterdata(json.value);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
    
            // Delay fetch slightly to avoid blocking render
        setTimeout(() => {
            fetchData();
        }, 0); // Immediate but non-blocking
    }, [navigate]);

    function onsubmit(){

        let body = {};
        body.token = Token.get();
        body.action = "create";
        body.amout = document.getElementById("event-create-input-event").value;
        body.event = document.getElementById("events").options[document.getElementById("events").selectedIndex].value;
        let response = post(body, "/EditEvents");
        if (!response){
            alert("Fehler beim anlegen der gruppe!")
            return;
        }
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        if (response == "EXISTINGEVENT"){
            alert("Event existiert bereits");
            return;
        }
        if (response == "OK"){
            alert("Event erfolgreich engelegt!")
            window.location.reload();
        }
        console.log(response);
    }
    return (
        <>
         <div onsubmit={onsubmit} style={{position: "absolute", left: "56%", top: "50%",boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',transform: "translate(-50%, -50%)",
         backgroundColor: "white", height: "40%", width: "50%",
         flexDirection:"column", justifyContent:  "flex-start", display: "flex", alignItems: "center"}} >
         <div style={{height: "12%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center",
             display: "flex",fontSize: "20px", color: "white", marginBottom: "5%"}}>
                <p>Event Erstellen</p>
            </div>
            <label for="events">Wähle aus:</label>
            <select style={{marginBottom: "5%"}} className="select-event-create-form" name="events" id="events">
                {loading ? (
                        <option value="">Loading</option>
                    ) : filteredata.length === 0 ? (
                        <option value="">No events found</option>
                    ) : (
                        filteredata.length > 0 ? (
                            filteredata.map((item, index) => (
                                <option key={index} value={item.int}>{item.desc}</option>

                            ))
                        ) : (
                            <option value="">No events found</option>
                        )
                    )}
            </select>
            <div>
                <label>Anzahl der hinzuzufügenden Punke</label>
            </div>
            <input style={{marginBottom: "5%"}} id="event-create-input-event" type="number" className="event-create-input-event" placeholder="0" required></input>
            <div style={{justifyContent: "space-evenly", width: "100%", display: "flex"}}>
             <Stylebutton buttonText={"Abbrechen"} click={() => setmask(false)}></Stylebutton>
             <div onClick={onsubmit}><Stylebutton buttonText={"Speichern"} ></Stylebutton></div>
            </div>

         </div>
        </>
    )

}
export default EventCreateForm;